import React from 'react';
import AnswerChecker from '../AnswerChecker';

// The third column is scratch space for the solver — nothing reads it back.
const clues = [
  ["MELT", "423"],
  ["8 SIDES", "321"],
  ["NIMBUS", "234"],
  ["H₂O", "514"],
  ["WORD BEFORE HEN OR TERESA", "653"],
  ["SKIN", "531"],
  ["NOT LAST", "234"],
  ["FLOWER FOUND IN EASTER", "341"],
  ["NAP", "342"],
  ["MALE GOOSE", "651"],
  ["OMEN", "31"],
];

export default function WordNumbers(props:any) {
  const {onNextGame}=props;

  return <>
  <table>
    <tbody>
      {clues.map(([clue, digits]) => (
        <tr key={clue}>
          <td>{clue}</td>
          <td>{digits}</td>
          <td><input type='text' style={{width: '32pt'}}></input></td>
        </tr>
      ))}
      </tbody>
  </table>

     <AnswerChecker onNextGame={onNextGame} correctAnswer="c55d455444c0c82145b2d272ad7baeaf413367886be519ad1ea15cefa7fb8c19"/>
      </>
}
